export const daliHelvarConstants = {
    HELVAR_GROUP_LIST_REQUEST: "HELVAR_GROUP_LIST_REQUEST",
    HELVAR_GROUP_LIST_SUCCESS: "HELVAR_GROUP_LIST_SUCCESS",
    HELVAR_GROUP_LIST_FAILURE: "HELVAR_GROUP_LIST_FAILURE",
    HELVAR_CLEAR: "HELVAR_CLEAR",

    HELVAR_SCENE_LIST_REQUEST: "HELVAR_SCENE_LIST_REQUEST",
    HELVAR_SCENE_LIST_SUCCESS: "HELVAR_SCENE_LIST_SUCCESS",
    HELVAR_SCENE_LIST_FAILURE: "HELVAR_SCENE_LIST_FAILURE",

    HELVAR_GROUP_ITEM_REQUEST: "HELVAR_GROUP_ITEM_REQUEST",
    HELVAR_GROUP_ITEM_SUCCESS: "HELVAR_GROUP_ITEM_SUCCESS",
    HELVAR_GROUP_ITEM_FAILURE: "HELVAR_GROUP_ITEM_FAILURE",

    HELVAR_AREA_LIST_REQUEST: "HELVAR_AREA_LIST_REQUEST",
    HELVAR_AREA_LIST_SUCCESS: "HELVAR_AREA_LIST_SUCCESS",
    HELVAR_AREA_LIST_FAILURE: "HELVAR_AREA_LIST_FAILURE",

    HELVAR_AREA_ITEM_REQUEST: "HELVAR_AREA_ITEM_REQUEST",
    HELVAR_AREA_ITEM_SUCCESS: "HELVAR_AREA_ITEM_SUCCESS",
    HELVAR_AREA_ITEM_FAILURE: "HELVAR_AREA_ITEM_FAILURE",

    HELVAR_VALIDATION_FORM: "HELVAR_VALIDATION_FORM"
};
